import {FirmUserRoleStatus} from '@sollapay/enums';
import {useTranslation} from 'react-i18next';

import {ConfirmActionModal, InlineError} from '@/components';

import type {FirmMemberDTO} from '@sollapay/types';
import type {FC} from 'react';

export interface RemoveMemberModalProps {
  /** The member pending removal, or `null` when the modal should stay closed. */
  member: FirmMemberDTO | null;
  onConfirm: () => void;
  onClose: () => void;
  isLoading?: boolean;
  error?: unknown;
}

export const RemoveMemberModal: FC<RemoveMemberModalProps> = ({
  member,
  onConfirm,
  onClose,
  isLoading = false,
  error
}) => {
  const {t} = useTranslation('team');
  const isPending = member?.status === FirmUserRoleStatus.PENDING;
  const name = member?.name ?? member?.email ?? '';

  return (
    <ConfirmActionModal
      isOpen={member !== null}
      headerAlign="start"
      title={t(isPending ? 'removeModal.cancelTitle' : 'removeModal.removeTitle')}
      description={t(
        isPending ? 'removeModal.cancelDescription' : 'removeModal.removeDescription',
        {
          name
        }
      )}
      confirmLabel={t(isPending ? 'removeModal.cancelConfirm' : 'removeModal.removeConfirm')}
      onConfirm={onConfirm}
      onClose={onClose}
      isLoading={isLoading}
    >
      {error != null && <InlineError error={error} />}
    </ConfirmActionModal>
  );
};
